"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionLegacy = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = __importDefault(require("react"));
const constants_1 = require("../../../../entities/contracts/constants");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const IconListItem_1 = require("../../../components/icon-list-item/IconListItem");
const ChannelIcon_1 = require("../../../components/icon/ChannelIcon");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const Section_1 = require("../../../components/section/Section");
const Spacer_1 = require("../../../components/spacer/Spacer");
const theme_1 = __importDefault(require("../../../components/styles/theme"));
const helpers_1 = require("../marketing-channels/helpers");
const CommissionStyle = styled_1.default.div `
	width: 100%;

	img {
		vertical-align: middle;
	}

	.wrapper {
		display: inline-block;
		vertical-align: middle;
		padding-left: 10px;
	}

	.channel-name {
		display: block;
		${theme_1.default.typography.a2}
	}

	.channel-sub {
		display: inline-block;
		${theme_1.default.typography.c2}
	}

	.right {
		float: right;
		line-height: 40px;
	}

	.commission-percent {
		display: inline-block;
		vertical-align: middle;
		${theme_1.default.typography.a2}
	}
`;
const ChannelCommission = ({ channelId, channelName, commissionPct, affiliateCount }) => {
    const commission = commissionPct === undefined ? 15 : commissionPct;
    return (react_1.default.createElement(CommissionStyle, { id: channelId },
        react_1.default.createElement(Spacer_1.Spacer, null),
        react_1.default.createElement("div", null,
            react_1.default.createElement(ChannelIcon_1.ChannelIcon, { channel: channelId }),
            react_1.default.createElement("span", { className: "wrapper" },
                react_1.default.createElement("span", { className: "channel-name" }, channelName),
                affiliateCount !== 0 && react_1.default.createElement("span", { className: "channel-sub" }, (0, helpers_1.getSubHeading)(affiliateCount))),
            react_1.default.createElement("div", { className: "right" },
                react_1.default.createElement("span", { className: "commission-percent" },
                    commission,
                    "%"))),
        react_1.default.createElement(Spacer_1.Spacer, null),
        react_1.default.createElement(HorizontalRule_1.HorizontalRule, null)));
};
const CommissionLegacy = (props) => {
    const {} = props;
    return react_1.default.createElement("div", { "data-testid": 'legacy-commission' },
        react_1.default.createElement(HorizontalRule_1.HorizontalRule, null),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "large" }),
        react_1.default.createElement(Section_1.Section, { heading: "How our fees work" },
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(IconListItem_1.IconListItem, { icon: "star", display: "primary", iconSize: 1.875 },
                react_1.default.createElement("p", null, "Travelnest takes a percentage fee from all bookings generated through our platform.")),
            react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
            react_1.default.createElement(IconListItem_1.IconListItem, { icon: "star", display: "primary", iconSize: 1.875 },
                react_1.default.createElement("p", null, "You pay one fee per booking, as shown below. This includes the channel fee and all processing fees.")),
            react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
            react_1.default.createElement(IconListItem_1.IconListItem, { icon: "star", display: "primary", iconSize: 1.875 },
                react_1.default.createElement("p", null, "For UK-based customers, we'll charge VAT on the fees which will be deducted from your payout.")),
            react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
            react_1.default.createElement(IconListItem_1.IconListItem, { icon: "star", display: "primary", iconSize: 1.875 },
                react_1.default.createElement("p", null, "The value of this fee varies depending on the channel the booking is received from as shown below."))),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "large" }),
        react_1.default.createElement(MarginWrapper_1.MarginWrapper, null,
            react_1.default.createElement("section", { id: "channel_percentages" },
                react_1.default.createElement(HorizontalRule_1.HorizontalRule, null),
                constants_1.CHANNELS.map((ch) => (react_1.default.createElement(ChannelCommission, { channelId: ch.id, channelName: ch.display_name, commissionPct: ch.commission, affiliateCount: ch.affiliates.length }))))));
};
exports.CommissionLegacy = CommissionLegacy;
//# sourceMappingURL=CommissionLegacy.js.map